<template>
    <div v-on:click="clicked" id="landingPageBackground">
        <img class="centered-logo" src="../assets/Logo-light.svg">
    </div>
</template>

<script>
  export default {
      data() {
          return {
          }
      },
      methods: {
          clicked() {
              this.$router.push('/home')
          }
      },
      beforeCreate() {
          document.body.className = "landingpage"
      }
  }
</script>
<style lang="sass" scoped>

    #landingPageBackground
        height: 100vh
        width: 100vw
        cursor: pointer

    .centered-logo
        position: fixed
        height: 50vh
        width: auto
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

</style>
